import Base from '@studiometa/js-toolkit';
import inlineSVG from 'inline-svg';
import AOS from 'aos';
import { isDev } from './config';

import Marques from './components/Marques';
import Header from './components/Header';
import Solutions from './components/Solutions';
import Reviews from './components/Reviews';
import Expertise from './components/Expertise';
import SectionsNav from './components/SectionsNav';
import Accordion from './components/Accordion';
import VideoPlayer from './components/VideoPlayer';
import Filters from './components/Filters';
import GlossaryNav from './components/GlossaryNav';
import FeaturedCaseStudies from './components/FeaturedCaseStudies';
import Loader from './components/Loader';
import FrontPageVideo from './components/FrontPageVideo';
import AnimatedImage from './components/AnimatedImage';
import Form from './components/Form';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @return {Object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Accordion,
      Marques,
      Header,
      Solutions,
      Reviews,
      Expertise,
      SectionsNav,
      VideoPlayer,
      Filters,
      GlossaryNav,
      FeaturedCaseStudies,
      Loader,
      FrontPageVideo,
      AnimatedImage,
      Form,
    },
  };

  /**
   * Log a nice message when app is ready.
   *
   * @return {void}
   */
  mounted() {
    this.$log('mounted 🎉');

    inlineSVG.init({
      svgSelector: 'img.js-inline-svg',
    });

    AOS.init({
      duration: 1400,
      once: true,
    });
  }
}

const app = new App(document.documentElement);
app.$mount();
export default app;
